export class UpdatePubType {
  regulatorId: number;
  pubType: string;
  isActive: boolean;
  jurisdictionId: number;
  updatesDB_Id:number;

  constructor() {
    this.regulatorId = 0;
    this.pubType = '';
    this.isActive = false;
    this.jurisdictionId = 0;
    this.updatesDB_Id=0;
  }
}
